import React from "react"
import types from "prop-types"
import ItemRow from "shared/ItemRow"
import UserInfo from "shared/UserInfo"
import { CircularIconButton } from "shared/buttons"

const MemberList = ({ members, deleteGroupMembership }) => (
  <div>
    {
      members.map((member) => (
        <ItemRow
          key={member.id}
          itemRowHeaderContent={(
            <UserInfo user={member} showContentIfInactive={false} />
          )}
          itemRowHeaderControls={(
            <CircularIconButton
              ariaLabel="remove member from group"
              icon="close"
              onClick={() => deleteGroupMembership(member.id)}
            />
          )}
        />
      ))
    }
  </div>
)

MemberList.propTypes = {
  members: types.arrayOf(types.object).isRequired,
  deleteGroupMembership: types.func.isRequired,
}

export default MemberList
